import { FNIType, STATES } from '@upstart/harmony/lib/legos/constants';
import { GlobalConfigurationsData } from '@upstart/harmony/lib/legos/globalConfigurationTypes';
import { Dealer } from '../types/dealerTypes';
import { LendingStatus } from './constants';
import { LaunchPadService } from '../services/LaunchPadService';

export const completedBusinessInfo = (dealer: Dealer) =>
  !!dealer.lending?.businessInfo?.dealershipName;

export const completedFinanceContact = (dealer: Dealer) =>
  !!dealer.lending?.contactInfo?.name && !!dealer.lending?.contactInfo?.phone;

export const completedFinanceHours = (dealer: Dealer) =>
  !!dealer.lending?.businessHours;

export const completedPaymentInfo = (dealer: Dealer) =>
  !!dealer.lending?.paymentInfo;

export const startedLending = (dealer: Dealer) =>
  completedFinanceContact(dealer) ||
  completedFinanceHours(dealer) ||
  completedPaymentInfo(dealer);

export const completedLending = (dealer: Dealer) =>
  completedFinanceContact(dealer) &&
  completedFinanceHours(dealer) &&
  completedPaymentInfo(dealer);

export const getLendingStatus = (
  dealer: Dealer,
  globalConfigurations: GlobalConfigurationsData | null,
) => {
  const lendingStates: Array<keyof typeof STATES> =
    globalConfigurations?.LendingSupportedStates || [];
  const lendingFniType: Array<keyof typeof FNIType> =
    globalConfigurations?.LendingSupportedFNITypes || [];
  const state = dealer.state as keyof typeof STATES;
  const fniType = dealer.fniType?.toUpperCase() as keyof typeof FNIType;

  if (lendingFniType.includes(fniType) && lendingStates.includes(state)) {
    return LendingStatus.Enabled;
  } else if (lendingFniType.includes(fniType)) {
    return LendingStatus.StateDisabled;
  }

  return LendingStatus.Disabled;
};

export const submitLendingData = async (
  dealer: Dealer,
  globalConfigurations: GlobalConfigurationsData | null,
) => {
  const lendingStatus = getLendingStatus(dealer, globalConfigurations);
  if (lendingStatus === LendingStatus.Enabled) {
    if (dealer?.lending?.submittedLendingInfo) {
      return LaunchPadService.updateDealerLending({ dealerId: dealer.id });
    }

    return LaunchPadService.setupLendingEnabledDealer({
      dealerId: dealer.id,
    }).catch(() => {
      // no opp
    });
  }
  return false;
};
